import styled, { keyframes } from "styled-components";

import spinnerIcon from "assets/images/spinner.png";
import loader from "assets/images/loader.gif";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: max-content;
  width: fit-content;
  margin: auto;

  &.cover {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100vh;
  }

  .gif {
    height: 48px;
  }
`;

const spin = keyframes`
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
`;

const Spinner = styled.img`
  height: 24px;
  width: 24px;
  animation: ${spin} 0.5s linear infinite;
`;

const BarLoader = styled.div`
  .barloader {
    margin: 50px auto;
    display: block;
    width: 0;
    height: 6px;
    border-radius: 30px;
    border-right: 100px solid var(--secondary);
    border-left: 0px solid #fff;
    box-shadow: 0 0 0 1px #fff;
    animation: barloader infinite 1s linear;
  }

  @keyframes barloader {
    0% {
      border-right: 100px solid var(--secondary);
      border-left: 0px solid #fff;
    }
    50% {
      border-left: 100px solid var(--secondary);
      border-right: 0px solid #fff;
      border-radius: 30px;
    }
  }
`;

/**
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.type]
 * @returns
 */

const Loader = ({ className, type }) => {
  if (type === "spinner")
    return (
      <Wrapper>
        <Spinner className={className} src={spinnerIcon} alt="spinner" />
      </Wrapper>
    );

  if (type === "bar")
    return (
      <BarLoader>
        <div className="barloader"></div>
      </BarLoader>
    );

  return (
    <Wrapper className={className}>
      <img src={loader} alt="loader" className="gif" />
    </Wrapper>
  );
};

export default Loader;
